import React, { h } from 'preact'
import { LOGOS } from 'grosella/utils'

import style from './logo.css'

const LOGO = `${LOGOS}/logo-trimmed_transparent-background.png`

export const Logo: React.FunctionalComponent = () => {
    return <img src={LOGO} className={style.root} />
}
